import { useTranslation } from 'react-i18next';
import { AnimatedSection } from '../../../components/AnimatedSection';

const certifications = [
  { name: 'Cisco CCNP', icon: 'ri-award-line', color: 'text-cyan-400' },
  { name: 'Fortinet NSE', icon: 'ri-shield-check-line', color: 'text-emerald-400' },
  { name: 'Palo Alto PCNSE', icon: 'ri-lock-password-line', color: 'text-orange-400' },
  { name: 'Microsoft Azure', icon: 'ri-cloud-line', color: 'text-blue-400' },
  { name: 'AWS Solutions', icon: 'ri-server-line', color: 'text-yellow-400' },
  { name: 'ISACA Member', icon: 'ri-verified-badge-line', color: 'text-purple-400' },
];

const reasonKeys = [
  { icon: 'ri-team-line', titleKey: 'feat_r1_title', descKey: 'feat_r1_desc' },
  { icon: 'ri-customer-service-2-line', titleKey: 'feat_r2_title', descKey: 'feat_r2_desc' },
  { icon: 'ri-lock-2-line', titleKey: 'feat_r3_title', descKey: 'feat_r3_desc' },
  { icon: 'ri-building-line', titleKey: 'feat_r4_title', descKey: 'feat_r4_desc' },
];

export default function Features() {
  const { t } = useTranslation();

  return (
    <section className="bg-slate-900 py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Why Choose Us */}
          <AnimatedSection animation="fade-in">
            <div>
              <span className="text-cyan-400 text-sm font-semibold tracking-widest uppercase">
                {t('features_badge')}
              </span>
              <h2 className="text-4xl font-bold text-white mt-3 mb-4">
                {t('features_title1')}<br />
                <span className="text-cyan-400">{t('features_title2')}</span>
              </h2>
              <p className="text-slate-400 mb-10 leading-relaxed">{t('features_desc')}</p>

              <div className="grid sm:grid-cols-2 gap-6">
                {reasonKeys.map((r) => (
                  <div key={r.titleKey} className="flex gap-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-cyan-500/10 rounded-lg shrink-0 mt-0.5">
                      <i className={`${r.icon} text-cyan-400 text-lg`}></i>
                    </div>
                    <div>
                      <h4 className="text-white font-semibold text-sm mb-1">{t(r.titleKey)}</h4>
                      <p className="text-slate-400 text-xs leading-relaxed">{t(r.descKey)}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </AnimatedSection>

          {/* Right: Certifications */}
          <AnimatedSection animation="fade-in" delay={0.2}>
            <div className="bg-slate-800/50 border border-slate-700 rounded-2xl p-8">
              <h3 className="text-white font-bold text-lg mb-2">{t('cert_title')}</h3>
              <p className="text-slate-400 text-sm mb-8">{t('cert_desc')}</p>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                {certifications.map((cert) => (
                  <div key={cert.name} className="bg-slate-900 border border-slate-700 rounded-xl p-4 text-center">
                    <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                      <i className={`${cert.icon} text-2xl ${cert.color}`}></i>
                    </div>
                    <p className="text-white text-xs font-medium">{cert.name}</p>
                  </div>
                ))}
              </div>

              <div className="mt-8 pt-6 border-t border-slate-700 flex items-center justify-between">
                <div className="text-center">
                  <div className="text-2xl font-bold text-cyan-400">200+</div>
                  <div className="text-slate-400 text-xs mt-1">{t('cert_completed')}</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-cyan-400">100%</div>
                  <div className="text-slate-400 text-xs mt-1">{t('cert_satisfaction')}</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-cyan-400">0</div>
                  <div className="text-slate-400 text-xs mt-1">{t('cert_incidents')}</div>
                </div>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}
